import { __assign, __rest } from "tslib";
import React from 'react';
import { PennyMacContext } from './PnmacContext';
function useTheme() {
  var pnmac = React.useContext(PennyMacContext);
  return pnmac;
}
export function withContextCreator() {
  return function (Component, name) {
    if (name === void 0) {
      name = "Component";
    }
    return /*#__PURE__*/React.forwardRef(function PnmacTheme(props, ref) {
      var innerRef = props.innerRef,
        other = __rest(props, ["innerRef"]);
      var pn = useTheme();
      //console.log("Theme Provider 123", pn);
      return /*#__PURE__*/React.createElement(Component, __assign({}, pn, {
        ref: innerRef || ref
      }, other));
    });
    ;
  };
  ;
}
var withPnmacContext = withContextCreator();
export default withPnmacContext;